module.exports = __webpack_public_path__ + "static/media/whatsapp-brand.af153085.png";